import { render, staticRenderFns } from "./CampaignOverview.vue?vue&type=template&id=74640997&lang=pug&"
import script from "./CampaignOverview.vue?vue&type=script&lang=js&"
export * from "./CampaignOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports